export { View as Tab2018 } from './view'
